/*
 * @Author: 李文敬
 * @version: 1.0.0
 * @Company: 和顺旭基(深圳)中医药科技有限公司
 * @Description:
 * @Date: 2021-06-21 14:49:25
 * @LastEditors: 李文敬
 * @LastEditTime: 2022-08-05 10:55:40
 */
import { Encrypt, Decrypt } from '@/utils/secret'
import { LocPrefix } from '@/config'

/**
 * 扁平化数据转化成树形数据
 * @param {Array} data 需转化的原数据
 */
export function transformationalTreeData(data) {
  // 删除所有的children,以防止多次调用
  data.forEach(item => { delete item.children })
  const map = {} // 构建map
  data.forEach(i => {
    map[i.id] = i // 构建以id为键 当前数据为值
  })
  const treeData = []
  data.forEach(child => {
    const mapItem = map[child.parent_id] // 判断当前数据的parentId是否存在map中
    if (mapItem) {
      // 存在则表示当前数据不是最顶层的数据
      (mapItem.children || (mapItem.children = [])).push(child) // 这里判断mapItem中是否存在child
    } else { treeData.push(child) }
  })
  return treeData
}

/**
 * 强制布尔类型转换
 * @param {Object} value 需要转换的值
 */
export function coerceBoolean(value) {
  return (
    value !== null &&
    value !== undefined &&
    `${value}` !== 'false' &&
    `${value}` !== 'NaN' &&
    `${value}` !== ''
  )
}
/**
 * 普通日期格式化
 * @param {*} time 需要格式化的日期
 * @param {*} format 需要转换成的时间格式 'yyyy-MM-dd HH:mm:ss' / 'yyyy-MM-dd'
 */
export const timeFormat = (time, format) => {
  let _time = time
  if (!coerceBoolean(_time)) return ''
  if (/^\d{4}-\d{2}-\d{2}\s\d{2}:\d{2}:\d{2}(\.0)?$/g.test(_time)) {
    // ‘2018-08-21 15:28:00’这种格式ie浏览器不兼容
    _time = _time.replace(/-/g, '/')
    _time = _time.replace(/(\.0)?$/i, '')
  }
  const t = new Date(_time)
  const y = t.getFullYear()
  let M = t.getMonth() + 1
  if (M < 10) M = '0' + M
  let d = t.getDate()
  if (d < 10) d = '0' + d
  let H = t.getHours()
  if (H < 10) H = '0' + H
  let m = t.getMinutes()
  if (m < 10) m = '0' + m
  let s = t.getSeconds()
  if (s < 10) s = '0' + s
  return format
    .replace(/yyyy/, y)
    .replace(/MM/, M)
    .replace(/dd/, d)
    .replace(/HH/, H)
    .replace(/mm/, m)
    .replace(/ss/, s)
}

/**
 * @name: 李文敬
 * @method: 深拷贝
 * @param {*} data 数据
 * @Date: 2021-09-23 16:22:03
 */
export function deepCopy(data) {
  return JSON.parse(JSON.stringify(data))
}

/**
 * @name: 李文敬
 * @method: 设置本地缓存
 * @param {String} key 键名
 * @param {*} value 内容
 * @param {Number} json json
 * @param {Number} prefix 是否拼接前缀
 * @Date: 2021-09-23 16:22:03
 */
export function setLoc({ key, value, json = 0, prefix = 1 }) {
  prefix = prefix === 1 ? LocPrefix : ''
  localStorage.setItem(
    `${prefix}${Encrypt(key)}`,
    json ? Encrypt(JSON.stringify(value)) : Encrypt(value)
  )
}

/**
 * @name: 李文敬
 * @method: 获取本地缓存
 * @param {String} key 键名
 * @param {Number} json json
 * @param {Number} prefix 是否拼接前缀
 * @Date: 2021-09-23 16:22:03
 */
export function getLoc({ key, json = 0, prefix = 1 }) {
  prefix = prefix === 1 ? LocPrefix : ''
  if (localStorage.getItem(`${prefix}${Encrypt(key)}`)) {
    if (json) {
      return JSON.parse(
        Decrypt(localStorage.getItem(`${prefix}${Encrypt(key)}`))
      )
    } else {
      return Decrypt(localStorage.getItem(`${prefix}${Encrypt(key)}`))
    }
  } else {
    return ''
  }
}

/**
 * @name: 李文敬
 * @method: 删除本地缓存
 * @param {String} key 键名
 * @param {Number} prefix 是否拼接前缀
 * @Date: 2021-09-23 16:22:03
 */
export function delLoc({ key, prefix = 1 }) {
  prefix = prefix === 1 ? LocPrefix : ''
  localStorage.removeItem(`${prefix}${Encrypt(key)}`)
}



// WEBPACK FOOTER //
// ./src/utils/index.js